import { createContext, useContext } from "react";
import type { Store } from "./Store";

export const Context = createContext({} as Store);
export const useStore = () => useContext(Context);
